
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vps",
      function () {
        return require("private-next-pages/vps.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vps"])
      });
    }
  